import type { HandleClientError } from '@sveltejs/kit';

// After a new deploy, clients still running the previous build hold references
// to old hashed asset chunks that no longer exist. Detect those failures and
// force a single hard reload so the user picks up the new build instead of
// seeing a broken page.
const STALE_RELOAD_KEY = 'bubble-games-stale-chunk-reload';
function isStaleChunkError(err: unknown): boolean {
	const msg = err instanceof Error ? `${err.name}: ${err.message}` : String(err);
	return (
		/Unable to preload CSS/i.test(msg) ||
		/Failed to fetch dynamically imported module/i.test(msg) ||
		/Importing a module script failed/i.test(msg) ||
		/error loading dynamically imported module/i.test(msg)
	);
}
function reloadOnce() {
	try {
		// Guard against reload loops if the new build is also broken.
		const last = Number(sessionStorage.getItem(STALE_RELOAD_KEY) ?? '0');
		if (Date.now() - last < 10_000) return;
		sessionStorage.setItem(STALE_RELOAD_KEY, String(Date.now()));
	} catch {}
	location.reload();
}

export const handleError: HandleClientError = ({ error }) => {
	if (isStaleChunkError(error)) reloadOnce();
};

// SvelteKit's generated client expects an optional `init` hook export. Provide
// an explicit no-op so the bundler doesn't warn about the missing import.
export const init = () => {};
